export default class App {

    static redirect = url => location.href = url;
    static reloadPage = () => location.reload();
    static scrollTo = (anchor) => location.href = anchor;
    static submitDelete = url => {
        const form = document.createElement('form');
        form.method = "POST";
        form.action = url;

        document.body.appendChild(form);

        form.submit();

    }

    static openNewTab = url => {
        Object.assign(document.createElement('a'), {
            target: '_blank',
            rel: 'noopener noreferrer',
            href: url,
        }).click();
    }
}